import React from "react";
import { View, Button, Text, Icon } from "ui";
import { styled } from "styles";
import { Modal } from "@material-ui/core";
import windowSize from "react-window-size";

const PhoneImg = require("../assets/DownloadPhoneApp.png");
const GooglePlayButton = require("../assets/GooglePlayButton.png");
const AppStoreButton = require("../assets/AppStoreButton.png");
const elipse = require("../assets/elipse.png");

interface P {
  windowWidth: number;
}

class InstallApp extends React.Component<P> {
  public state = {
    isMobile: false
  };

  public componentDidMount() {
    this.setState({ isMobile: this.props.windowWidth < 1200 });
  }

  public handleClose = () => {
    this.setState({ isMobile: false });
  }

  public handleGoogle = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=ro.csabai.verificarca",
      "_blank"
    );
  }

  public handleStore = () => {
    window.open(
      "https://itunes.apple.com/us/app/automemo/id1228928929",
      "_blank"
    );
  }
  public render = () => {
    return (
      <Container
        flex={1}
        ml={2}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Elipse src={elipse} />
        <Phone src={PhoneImg} />
        <GoogleButton src={GooglePlayButton} onClick={this.handleGoogle} />

        <StoreButton src={AppStoreButton} onClick={this.handleStore} />
        <View>
          <Modal open={this.state.isMobile} onClose={this.handleClose}>
            <ModalView
              bg="transparent"
              alignItems="center"
              justifyContent="center"
            >
              <CloseButton onClick={this.handleClose}>
                <Icon name="close-circle" size={3} />
              </CloseButton>
              <Phone src={PhoneImg} />
              <GoogleButton
                src={GooglePlayButton}
                onClick={this.handleGoogle}
              />
              <StoreButton src={AppStoreButton} onClick={this.handleStore} />
            </ModalView>
          </Modal>
        </View>
      </Container>
    );
  }
}

export default windowSize(InstallApp);

const CloseButton = styled(View)`
  position: absolute;
  bottom: 30rem;
  right: 2rem;
  cursor: pointer;
`;

const Container = styled(View)`
  position: relative;
  height: 50rem;
  @media (max-width: 1290px) {
    display: none;
  }
`;

const Elipse = styled.img`
  width: 30rem;
  height: 42rem;
  top: 0rem;
  right: 0rem;
  position: absolute;
`;

const Phone = styled.img`
  max-width: 35rem;
  max-height: 35rem;
  position: absolute;
  top: 7rem;
  right: 4rem;

  @media (max-width: 1290px) {
    max-width: 35rem;
    max-height: 35rem;
  }
`;

const GoogleButton = styled.img`
  max-width: 15rem;
  max-height: 15rem;
  position: absolute;
  bottom: 8.5rem;
  cursor: pointer;
  right: 5.7rem;

  /* @media (max-width: 1290px) {
    max-width: 11rem;
    max-height: 11rem;
    bottom: 2rem;
  } */
`;

const StoreButton = styled.img`
  max-width: 15rem;
  max-height: 15rem;
  position: absolute;
  bottom: 13rem;
  cursor: pointer;
  right: 5.7rem;

  /* @media (max-width: 1290px) {
    max-width: 11rem;
    max-height: 11rem;
    bottom: 6rem;
  } */
`;

const ModalView = styled(View)`
  height: 100%;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/InstallApp.tsx